module.exports = __webpack_public_path__ + "static/media/play-player-egg-broken.a28e3b84.png";